<div fxLayout="row" class="container" fxFlex="100" fxLayoutAlign="space-between" [formGroup]="formGroup">
  <!-- First column -->
  <div class="column" fxLayout="column" fxFlex="24">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'Company' | translate }}</mat-label>
      <input
        matInput
        formControlName="company"
        placeholder="{{ 'Company' | translate }}"
        [matAutocomplete]="autocompleteEmployer"
        [errorStateMatcher]="matcher"
        tabindex="1"
        />
        <mat-autocomplete #autocompleteEmployer="matAutocomplete" [displayWith]="displayValue">
          @for (company of companies$ | async; track company) {
            <mat-option [value]="company">
              {{ company.Name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <div class="control">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'WorkingTimeStart' | translate }}</mat-label>
          <input
            matInput
            [ngxMatTimepicker]="timeStartPicker"
            formControlName="timeStart"
            format="24"
            placeholder="16:00"
            [max]="timeEnd.value"
            readonly
            tabindex="5"
            />
            <ngx-mat-timepicker #timeStartPicker color="accent"></ngx-mat-timepicker>
            <mat-icon matSuffix (click)="timeStartPicker.open()"> watch_later</mat-icon>
          </mat-form-field>
        </div>


        <div class="control">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'WorkingTimeEnd' | translate }}</mat-label>
            <input
              matInput
              [ngxMatTimepicker]="timeEndPicker"
              formControlName="timeEnd"
              format="24"
              placeholder="16:00"
              [min]="timeStart.value"
              readonly
              tabindex="9"
              />
              <ngx-mat-timepicker #timeEndPicker color="accent"></ngx-mat-timepicker>
              <mat-icon matSuffix (click)="timeEndPicker.open()"> watch_later</mat-icon>
            </mat-form-field>
          </div>
        </div>

        <!-- Second column -->
        <div class="column" fxLayout="column" fxFlex="24">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'EmployerObject' | translate }}</mat-label>
            <input
              matInput
              formControlName="employerObject"
              [placeholder]="'EmployerObject' | translate"
              [matAutocomplete]="autocompleteEmployerObject"
              [errorStateMatcher]="matcher"
              tabindex="2"
              />
              <mat-autocomplete #autocompleteEmployerObject="matAutocomplete" [displayWith]="displayValue">
                @for (employerObject of employerObjects$ | async; track employerObject) {
                  <mat-option [value]="employerObject">
                    {{ employerObject.Name }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>

            <div class="control">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'EmploymentType' | translate }}</mat-label>
                <mat-select formControlName="employmentTypeId" multiple tabindex="6">
                  @for (type of employmentType$ | async; track type) {
                    <mat-option #matOption [value]="type.Id">{{ type.Name | translate }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

          </div>

          <!-- Third column -->
          <div class="column" fxLayout="column" fxFlex="24">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'LastName' | translate }}</mat-label>
              <input matInput type="text" formControlName="lastName" tabindex="3" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'Pesel' | translate }}</mat-label>
              <input matInput type="text" formControlName="pesel" tabindex="7" />
            </mat-form-field>
          </div>

          <!-- Four column -->
          <div class="column" fxLayout="column" fxFlex="24">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'FirstNameAbbreviated' | translate }}</mat-label>
              <input matInput type="text" formControlName="firstName" tabindex="4" />
            </mat-form-field>

            <div class="control">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'WorkMode' | translate }}</mat-label>
                <mat-select formControlName="workModeId" multiple tabindex="8">
                  @for (mode of workModes$ | async; track mode) {
                    <mat-option #matOption [value]="mode.Id">{{ mode.Name | translate }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

          </div>
        </div>
